import HomeCards from '../HomeCards'
import { Navigate } from 'react-router-dom'
import { getLoginItem, hasSidebar } from '../../utils'
import './Home.css'

export default function Home() {
  console.log('Home rendered')

  if (!getLoginItem('currentWorkspaceId')) {
    return <Navigate to={'/noWorkspaces'} />
  }
  if (!hasSidebar()) {
    return <HomeCards />
  }
  return <div data-cy-home-rendered={true} />
}
